export default function(fieldsList = [], field) {
  return fieldsList.some(
    obj =>
      Object.prototype.hasOwnProperty.call(obj, field) &&
      obj[field] !== '' &&
      obj[field] !== undefined &&
      obj[field] !== null
  )
}
